(function () {
  'use strict';

  var MONTHS = {
    pt: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
    es: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
    en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  };

  var COPY = {
    pt: {
      fastLabel: 'Entrega em 48h Úteis',
      slowLabel: 'Entrega em 3 - 14 dias úteis',
      slowLabelMobile: 'Entrega 3-14 dias úteis',
      fastDate: 'Previsão: até',
      fastDateMobile: 'Até',
      slowDate: 'Previsão: entre',
      slowDateMobile: 'Entre',
      slowJoin: 'e'
    },
    es: {
      fastLabel: 'Entrega en 48h Hábiles',
      slowLabel: 'Entrega en 3 - 14 días laborables',
      slowLabelMobile: 'Entrega 3-14 días laborables',
      fastDate: 'Previsión: hasta',
      fastDateMobile: 'Hasta',
      slowDate: 'Previsión: entre el',
      slowDateMobile: 'Entre el',
      slowJoin: 'y el'
    },
    en: {
      fastLabel: 'Delivery in 48 Business Hours',
      slowLabel: 'Delivery in 3 - 14 business days',
      slowLabelMobile: 'Delivery 3-14 business days',
      fastDate: 'ETA: by',
      fastDateMobile: 'By',
      slowDate: 'ETA: between',
      slowDateMobile: 'Between',
      slowJoin: 'and'
    }
  };

  function isWeekend(d) {
    var day = d.getDay();
    return day === 0 || day === 6;
  }

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (!isWeekend(d)) added++;
    }
    return d;
  }

  var MONTHS_SHORT = {
    pt: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
    es: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
    en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  };

  function isMobile() {
    return typeof window !== 'undefined' && window.innerWidth <= 767;
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function fmtDate(d, locale) {
    var months = MONTHS[locale] || MONTHS.pt;
    if (locale === 'en') {
      return months[d.getMonth()] + ' ' + d.getDate();
    }
    return d.getDate() + ' de ' + months[d.getMonth()];
  }

  function fmtDateShort(d, locale) {
    // Formato compacto numérico DD/MM
    return pad(d.getDate()) + '/' + pad(d.getMonth() + 1);
  }

  function fmtRange(d1, d2, locale, compact) {
    var copy = getCopy(locale);
    if (compact) {
      return fmtDateShort(d1, locale) + ' ' + copy.slowJoin + ' ' + fmtDateShort(d2, locale);
    }
    return fmtDate(d1, locale) + ' ' + copy.slowJoin + ' ' + fmtDate(d2, locale);
  }

  function getCopy(locale) {
    return COPY[locale] || COPY.pt;
  }

  function isInQuickView(el) {
    if (!el || !el.closest) return false;
    return !!el.closest('.popup-quick-view, [data-quick-view], [data-popup-quick-view], .quick-view, popup-quick-view, popup-quick-view-component');
  }

  function isInCart(el) {
    if (!el) return false;
    if (el.classList && el.classList.contains('lisabona-delivery--cart')) return true;
    if (el.closest && el.closest('.cart__item, [data-cart-drawer], .cart-drawer, #CartDrawer, drawer-element, .cart-template, .cart__items')) return true;
    return false;
  }

  function update(el) {
    var localeRaw = (el.getAttribute('data-locale') || 'pt').toLowerCase();
    var locale = localeRaw.split('-')[0];
    var hasStock = el.getAttribute('data-fast-stock') === 'true';
    var copy = getCopy(locale);
    var today = new Date();

    var labelEl = el.querySelector('[data-lisabona-delivery-label]');
    var dateEl = el.querySelector('[data-lisabona-delivery-date]');

    var mobile = isMobile();
    var quickView = isInQuickView(el);
    var inCart = isInCart(el);
    // Compacto (DD/MM) em mobile, dentro do popup quick add, OU dentro do cart drawer/cart page.
    var compact = mobile || quickView || inCart;

    if (hasStock) {
      var fastDate = addBusinessDays(today, 2);
      if (labelEl) labelEl.textContent = copy.fastLabel;
      if (dateEl) {
        var prefix = compact ? copy.fastDateMobile + ' ' : copy.fastDate + ' ';
        // Mobile/quick-view: DD/MM. Desktop PDP: extenso ("19 de maio").
        dateEl.textContent = prefix + (compact ? fmtDateShort(fastDate, locale) : fmtDate(fastDate, locale));
      }
    } else {
      var d1 = addBusinessDays(today, 3);
      var d2 = addBusinessDays(today, 14);
      if (labelEl) labelEl.textContent = compact && copy.slowLabelMobile ? copy.slowLabelMobile : copy.slowLabel;
      if (dateEl) {
        var prefix = compact ? copy.slowDateMobile : copy.slowDate;
        dateEl.textContent = prefix + ' ' + fmtRange(d1, d2, locale, compact);
      }
    }

    el.classList.toggle('lisabona-delivery--fast', hasStock);
  }

  function refreshAll() {
    document.querySelectorAll('[data-lisabona-delivery]').forEach(update);
  }

  function variantHasStock(variant) {
    if (!variant) return false;
    // Accept both snake_case (Shopify standard) and camelCase (some theme JSONs)
    var inv = variant.inventory_quantity;
    if (typeof inv !== 'number') inv = variant.inventoryQuantity;
    if (typeof inv === 'number') return inv > 0;
    if (typeof variant.available !== 'undefined') return !!variant.available;
    if (typeof variant.availableForSale !== 'undefined') return !!variant.availableForSale;
    return false;
  }

  // Lê o JSON de variants scoped (que está dentro do próprio bloco de delivery)
  function getScopedVariants(deliveryEl) {
    if (!deliveryEl) return null;
    var script = deliveryEl.querySelector('script[data-lisabona-variants]');
    if (!script) {
      // Fallback: procurar dentro do form ancestor
      var form = deliveryEl.closest && deliveryEl.closest('product-form, [data-product-form], .popup-quick-view, .popup-quick-view__form');
      if (form) script = form.querySelector('script[data-lisabona-variants]');
    }
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function variantHasStockScoped(deliveryEl, variantId) {
    var variants = getScopedVariants(deliveryEl);
    if (!variants || !Array.isArray(variants)) return null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(variantId)) {
        var inv = variants[i].inventory_quantity;
        if (typeof inv === 'number') return inv > 0;
        if (typeof variants[i].available !== 'undefined') return !!variants[i].available;
        return null;
      }
    }
    return null; // variant id not in this scope (different product)
  }

  // Encontra o "scope" (form/quick-view container) que contém a delivery
  function getScopeForDelivery(deliveryEl) {
    if (!deliveryEl || !deliveryEl.closest) return null;
    return deliveryEl.closest('product-form, [data-product-form], .popup-quick-view, .popup-quick-view__form, .popup-quick-view__inner') || deliveryEl.parentElement;
  }

  function applyVariantScoped(deliveryEl, variant) {
    if (!deliveryEl || !variant) return;
    // Se tivermos JSON scoped, usar essa info. Senão, fallback para a variant payload.
    var hasStock = variantHasStockScoped(deliveryEl, variant.id);
    if (hasStock === null) {
      // variant id não pertence a este produto → não atualizar (evita poluir delivery de outro produto)
      var scopedVariants = getScopedVariants(deliveryEl);
      if (scopedVariants) return;
      hasStock = variantHasStock(variant);
    }
    deliveryEl.setAttribute('data-fast-stock', hasStock ? 'true' : 'false');
    deliveryEl.setAttribute('data-current-variant-id', variant.id || '');
    update(deliveryEl);
  }

  function applyVariant(variant) {
    if (!variant) return;
    document.querySelectorAll('[data-lisabona-delivery]').forEach(function (el) {
      applyVariantScoped(el, variant);
    });
  }

  function findVariantByOptionsInScope(deliveryEl, options) {
    var variants = getScopedVariants(deliveryEl);
    if (!variants) return null;
    return variants.find(function (v) {
      return v.options && v.options.every(function (opt, idx) { return opt === options[idx]; });
    });
  }

  function getSelectedOptionsInScope(scopeEl) {
    if (!scopeEl) return [];
    var values = [];
    var radios = scopeEl.querySelectorAll('input[data-single-option-selector]:checked');
    radios.forEach(function (r) { if (r.value) values.push(r.value); });
    if (values.length === 0) {
      var hidden = scopeEl.querySelectorAll('input[data-popout-input]');
      hidden.forEach(function (h) { if (h.value) values.push(h.value); });
    }
    return values;
  }

  function refreshFromCurrent() {
    document.querySelectorAll('[data-lisabona-delivery]').forEach(function (el) {
      var scope = getScopeForDelivery(el);
      if (!scope) return;
      var opts = getSelectedOptionsInScope(scope);
      if (!opts.length) return;
      var v = findVariantByOptionsInScope(el, opts);
      if (!v) return;
      var hasStock = (typeof v.inventory_quantity === 'number') ? v.inventory_quantity > 0 : !!v.available;
      el.setAttribute('data-fast-stock', hasStock ? 'true' : 'false');
      el.setAttribute('data-current-variant-id', v.id || '');
      update(el);
    });
  }

  function refreshFromTarget(target) {
    if (!target || !target.closest) {
      refreshFromCurrent();
      return;
    }
    // Encontrar a delivery dentro do mesmo scope que o target
    var scope = target.closest('product-form, [data-product-form], .popup-quick-view, .popup-quick-view__form, .popup-quick-view__inner');
    if (!scope) {
      refreshFromCurrent();
      return;
    }
    var deliveries = scope.querySelectorAll('[data-lisabona-delivery]');
    if (!deliveries.length) {
      refreshFromCurrent();
      return;
    }
    deliveries.forEach(function (el) {
      var opts = getSelectedOptionsInScope(scope);
      if (!opts.length) return;
      var v = findVariantByOptionsInScope(el, opts);
      if (!v) return;
      var hasStock = (typeof v.inventory_quantity === 'number') ? v.inventory_quantity > 0 : !!v.available;
      el.setAttribute('data-fast-stock', hasStock ? 'true' : 'false');
      el.setAttribute('data-current-variant-id', v.id || '');
      update(el);
    });
  }

  function watchInputs() {
    // Watch every individual size input on the form
    var radios = document.querySelectorAll('input[data-single-option-selector], input[data-popout-input]');
    radios.forEach(function (r) {
      if (r.__lisabonaWatched) return;
      r.__lisabonaWatched = true;
      r.addEventListener('change', function (e) {
        var t = e && e.target;
        setTimeout(function () { refreshFromTarget(t || r); }, 30);
      });
      r.addEventListener('click', function (e) {
        var t = e && e.target;
        setTimeout(function () { refreshFromTarget(t || r); }, 30);
      });
    });
  }

  function init() {
    refreshAll();
    watchInputs();

    if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS && window.theme.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function (payload) {
        var variant = payload && payload.data && payload.data.variant;
        if (variant) {
          applyVariant(variant);
        } else {
          refreshFromCurrent();
        }
      });
    }

    if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS && window.theme.PUB_SUB_EVENTS.optionValueSelectionChange) {
      window.subscribe(window.theme.PUB_SUB_EVENTS.optionValueSelectionChange, function (payload) {
        var t = payload && payload.data && (payload.data.target || payload.data.element);
        setTimeout(function () { refreshFromTarget(t); }, 30);
      });
    }

    document.addEventListener('change', function (e) {
      if (!e.target) return;
      var input = e.target.closest && e.target.closest('input[data-single-option-selector], select[data-single-option-selector], input[data-popout-input]');
      if (!input) return;
      setTimeout(function () { refreshFromTarget(input); }, 50);
    });

    document.addEventListener('click', function (e) {
      if (!e.target) return;
      var label = e.target.closest && e.target.closest('label.radio__label, .select-popout__option, .swatch__label');
      if (!label) return;
      setTimeout(function () { refreshFromTarget(label); }, 80);
    });

    document.addEventListener('variant:change', function (e) {
      var v = e.detail && (e.detail.variant || e.detail);
      if (v) applyVariant(v);
    });

    // Re-watch inputs e refrescar deliveries quando o DOM muda (popup quick view aberto, etc.)
    if (window.MutationObserver) {
      var refreshTimer;
      var mo = new MutationObserver(function (mutations) {
        watchInputs();
        // Se foi adicionado algum [data-lisabona-delivery] novo (ex: popup), refrescar
        var hasNewDelivery = false;
        mutations.forEach(function (m) {
          m.addedNodes && m.addedNodes.forEach(function (n) {
            if (n.nodeType !== 1) return;
            if (n.matches && n.matches('[data-lisabona-delivery]')) hasNewDelivery = true;
            if (n.querySelector && n.querySelector('[data-lisabona-delivery]')) hasNewDelivery = true;
          });
        });
        if (hasNewDelivery) {
          clearTimeout(refreshTimer);
          refreshTimer = setTimeout(refreshAll, 50);
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }

    // Quando popup quick view abre, força refresh
    document.addEventListener('click', function (e) {
      var trigger = e.target && e.target.closest && e.target.closest('[data-button-quick-view], .btn-quick-buy');
      if (!trigger) return;
      setTimeout(refreshAll, 300);
      setTimeout(refreshAll, 800);
    });

    // Re-render on resize (so mobile format kicks in on rotation/resize)
    var resizeTimer;
    var lastIsMobile = isMobile();
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var nowMobile = isMobile();
        if (nowMobile !== lastIsMobile) {
          lastIsMobile = nowMobile;
          refreshAll();
        }
      }, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
